import { render, staticRenderFns } from "./DecimalStyledNumber.vue?vue&type=template&id=353c949f&"
import script from "./DecimalStyledNumber.vue?vue&type=script&lang=js&"
export * from "./DecimalStyledNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports